import React from 'react';
import { Checkbox, Popup } from 'semantic-ui-react';

const scroll = {};
{
  /* <Checkbox
  key={idx}
  className={props.value.className} //className={data.className}
  value={String(props.value.id)}
  disabled={props.value.isDisabled}
  onChange={props.value.selectFunc}
  //checked={props.value.isAll}
  // onClick={(e) => fn.fnChecked(e, "", props.value)}
/> */
}
scroll.header = (headerData, fn, tooltipIdxArr) => {
  const header = [];
  headerData.forEach((data, idx) => {
    if (data.isChecked) {
      header.push({
        Header: (props) => {
          return (
            // <Checkbox onChange={(e, data) => fn.fnChecked(e, data, "all")} />
            <div className="checkbox pure">
              <label>
                <input
                  className={props.column.className}
                  type="checkbox"
                  onChange={(e, data) => fn.fnChecked(e, data, 'all')}
                />
                <span />
              </label>
            </div>
          );
        },
        accessor: String(idx),
        Cell: (props) => (
          <div key={idx} className="checkbox pure">
            <label>
              <input
                type="checkbox"
                id={props.value.id}
                name={props.value.name}
                className={props.value.className}
                disabled={props.value.isDisabled}
                onChange={props.value.selectFunc}
              />
              <span />
            </label>
          </div>
        ),
        sortable: false,
        width: data.width,
        maxWidth: data.width,
        headerClassName: data.headerClassName,
        className: data.className,
        style: data.style,
        headerStyle: data.headerStyle
      });
    } else if (tooltipIdxArr && tooltipIdxArr.includes(idx)) {
      header.push({
        Header: data.header,
        accessor: String(idx),
        Cell: (props) => {
          const { color, tooltip } = props.value || {};
          return (
            <Popup
              className="td-tooltip"
              inverted
              trigger={<span style={{ color: color || '' }}>{tooltip || ''}</span>}
              content={tooltip || ''}
            />
          );
        },
        width: data.width,
        style: data.style,
        className: data.className
      });
    } else if (data.notMaxWidth) {
      header.push({
        Header: data.header,
        accessor: String(idx),
        className: data.className
      });
    } else if (data.changeColor) {
      header.push({
        Header: data.header,
        accessor: String(idx),
        width: data.width,
        Cell: (props) => {
          const { color, data } = props.value || {};
          return <span style={{ color: color || '' }}>{data || ''}</span>;
        },
        headerClassName: data.headerClassName,
        className: data.className,
        style: data.style,
        headerStyle: data.headerStyle
      });
    } else if (data.clickAction) {
      header.push({
        Header: data.header,
        accessor: String(idx),
        width: data.width,
        Cell: (props) => <span onClick={(e) => fn.move(e, props)}>{props.value.data}</span>,
        headerClassName: data.headerClassName,
        className: data.className,
        style: data.style,
        headerStyle: data.headerStyle
      });
    } else {
      header.push({
        Header: data.header,
        // , style : data.style
        width: data.width,
        maxWidth: data.width,
        accessor: String(idx),
        headerClassName: data.headerClassName,
        className: data.className,
        style: data.style,
        headerStyle: data.headerStyle
      });
    }
  });

  return header;
};

/*
  무한 스크롤
  start : 시작 페이지
  end : 나눠서 보여줄 row 수
  data : 리스트 데이터
  isChecked : 체크박스 유무
*/
scroll.buildElements = (start, end, data) => {
  const elements = [];

  if (!data) {
    return elements;
  }

  for (let i = start; i < end; i++) {
    const temp = data[i];

    if (temp) {
      elements.push(temp);
    }
  }

  return elements;
};

scroll.event = (data, elements, containerHeight, heightIdx, elemLength) => {
  const count = Number(elemLength);
  const newElements = scroll.buildElements(count, count + 100, data);

  const infiniteParm = {
    isInfiniteLoading: false,
    heightIdx: 0,
    elements
  };

  if (!data) {
    return infiniteParm;
  }

  if (elements < data.length) {
    infiniteParm.heightIdx = heightIdx + containerHeight;
    infiniteParm.elements = newElements;
  }
  return infiniteParm;
};

export default scroll;
